import React, { useRef } from 'react';
import * as S from './style';
import { HostPlatform } from 'src/config/hostPlatform';
import { Subscription } from 'src/services/firebaseInit';
import {
  UrlType,
  useStripeCustomerPortal,
} from '../../hooks/useStripeCustomerPortal';
import { messages } from './messages';

interface NoLicenseErrorPageProperties {
  subscription: Subscription;
}

function JiraLicenseErrorPage() {
  return (
    <S.ErrorContainer>
      <div>
        <img src={process.env.PUBLIC_URL + '/img/settings.svg'} alt="error" />
        <S.ErrorText>
          <p>
            The license for Appgami Retrospectives is expired or invalid.
            Please, go to "Apps &gt; Manage Apps" and review the license
            configuration.
          </p>
          <p>
            If you believe this message is wrong, please contact your Jira admin
            or get in touch with our support team at support@appgami.com.
          </p>
        </S.ErrorText>
      </div>
    </S.ErrorContainer>
  );
}

function AzureLicenseErrorPage({ subscription }: NoLicenseErrorPageProperties) {
  const { portalUrl } = useStripeCustomerPortal(UrlType.PROJECT_URL);
  const linkRef = useRef<HTMLAnchorElement | null>(null);

  return (
    <S.ErrorContainer>
      <div>
        <S.ErrorTitle>
          {messages[subscription.type || 'paid'].title}
        </S.ErrorTitle>
        <img src={process.env.PUBLIC_URL + '/img/settings.svg'} alt="error" />
        <S.ErrorText>
          <p>{messages[subscription.type || 'paid'].body(subscription)}</p>
          <S.SubscribeButton
            onClick={() => {
              linkRef.current?.click();
            }}
          >
            {messages[subscription.type || 'paid'].button}
          </S.SubscribeButton>
          <a hidden={true} target="_top" ref={linkRef} href={portalUrl}>
            Link to portal
          </a>
        </S.ErrorText>
        <S.StripeBadge
          src={process.env.PUBLIC_URL + '/img/stripe-badge.svg'}
          alt="Powered by Stripe"
        />
      </div>
    </S.ErrorContainer>
  );
}

function NoLicenseErrorPage({ subscription }: NoLicenseErrorPageProperties) {
  return HostPlatform.isJira() ? (
    <JiraLicenseErrorPage />
  ) : HostPlatform.isAzure() ? (
    <AzureLicenseErrorPage subscription={subscription} />
  ) : (
    <span>Your license is invalid</span>
  );
}

export { NoLicenseErrorPage };
